import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/**
 * Infinite marquee (lusispro InfiniteMovingLogos pattern, CSS-driven so it's
 * SSR-perfect): content is rendered twice and the track translates -50% in a
 * loop. Pauses entirely under prefers-reduced-motion (see tailwind.css).
 */
export function Marquee({
  children,
  duration = 36,
  className,
}: {
  children: ReactNode;
  duration?: number;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'relative overflow-hidden',
        '[mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]',
        className
      )}
    >
      <div className="marquee-track flex w-max" style={{ animationDuration: `${duration}s` }}>
        <div className="flex shrink-0 items-center">{children}</div>
        <div aria-hidden="true" className="flex shrink-0 items-center">
          {children}
        </div>
      </div>
    </div>
  );
}
